import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Pagination from "../../components/common/pagination/Pagination";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { categoryListColumns } from "../../constant/tables-columns/tablesColums";
import { useNavigate } from "react-router";

export default function VendorStoreCategoryList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [categoryData, setCategoryData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getCategory = async (params) => {
    const path = "admin/vendorStoreProductCategories";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setCategoryData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getCategory({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getCategory(allFilter);
  };

  const data = [];

  categoryData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      isMain:item.isMain ? "true":"false",
      showInHomePage:item.showInHomePage ? "true":"false",
      parents: item.parents,
      name: item.name || "",
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editCategory = (singleCategory) => {
    navigate("/edit-vendor-store-category", { state: singleCategory });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست دسته بندی های غرفه"} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={categoryListColumns} rows={data} onEdit={editCategory} />
      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
